import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import About from '../components/sections/About';
import Founder from '../components/sections/Founder';
import Contact from '../components/sections/Contact';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Founder />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
